import type {PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {TabsActiveColor} from "../types/TabsActiveColor";
import {TabsTheme} from "../types/TabsTheme";
import {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";

import * as styles from "./Title.module.css";

interface IProps {
    activeColor?: TabsActiveColor;
    active: boolean;
    className?: string;
    dataTestId?: string;
    fullWidth?: boolean;
    gtmClick?: string;
    href?: string;
    onClick: () => void;
    theme: TabsTheme;
    variant: TabsVariant;
}

type ClassName = keyof typeof styles;

const getTitleTheme = (theme: TabsTheme) => `title${capitalize(theme)}` as ClassName;
const getTitleActiveColor = (color: TabsActiveColor) => `titleActiveColor${colorToClassName(color)}` as ClassName;

export const Title = (props: PropsWithChildren<IProps>) => {
    const {active, className, fullWidth, gtmClick, href, onClick, theme, variant, children, activeColor} = props;

    const isLineVariant = variant === "line";

    const classes = cn(
        styles.title,
        styles[getTitleTheme(theme)],
        {
            [styles.active]: active,
            [styles.line]: isLineVariant,
            [styles.wFull]: fullWidth
        },
        activeColor && styles[getTitleActiveColor(activeColor)],
        className
    );

    const handleClick = (e: React.MouseEvent) => {
        if (href) {
            e.preventDefault();
        }

        onClick();
    };

    if (href) {
        return (
            <a className={classes} data-gtm-click={gtmClick} data-name="tab-title" href={href} onClick={handleClick}>
                {children}
            </a>
        );
    }

    return (
        <div className={classes} data-gtm-click={props.gtmClick} data-name="tab-title" data-testid={props.dataTestId} onClick={props.onClick}>
            {props.children}
        </div>
    );
};
import type {PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {TabsActiveColor} from "../types/TabsActiveColor";
import {TabsTheme} from "../types/TabsTheme";
import {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";

import * as styles from "./Title.module.css";

interface IProps {
    activeColor?: TabsActiveColor;
    active: boolean;
    className?: string;
    dataTestId?: string;
    fullWidth?: boolean;
    gtmClick?: string;
    href?: string;
    onClick: () => void;
    theme: TabsTheme;
    variant: TabsVariant;
}

type ClassName = keyof typeof styles;

const getTitleTheme = (theme: TabsTheme) => `title${capitalize(theme)}` as ClassName;
const getTitleActiveColor = (color: TabsActiveColor) => `titleActiveColor${colorToClassName(color)}` as ClassName;

export const Title = (props: PropsWithChildren<IProps>) => {
    const {active, className, fullWidth, gtmClick, href, onClick, theme, variant, children, activeColor} = props;

    const isLineVariant = variant === "line";

    const classes = cn(
        styles.title,
        styles[getTitleTheme(theme)],
        {
            [styles.active]: active,
            [styles.line]: isLineVariant,
            [styles.wFull]: fullWidth
        },
        activeColor && styles[getTitleActiveColor(activeColor)],
        className
    );

    const handleClick = (e: React.MouseEvent) => {
        if (href) {
            e.preventDefault();
        }

        onClick();
    };

    if (href) {
        return (
            <a className={classes} data-gtm-click={gtmClick} data-name="tab-title" href={href} onClick={handleClick}>
                {children}
            </a>
        );
    }

    return (
        <div className={classes} data-gtm-click={props.gtmClick} data-name="tab-title" data-testid={props.dataTestId} onClick={props.onClick}>
            {props.children}
        </div>
    );
};
